import { SeDateTimeConfig } from './date-time-types'
import { DateTime } from 'luxon'

export const seDateTimeConfig: SeDateTimeConfig = {
  formats: require(`./date-time-formats.json`),
  deviceZone: DateTime.local().zoneName,
}
